export class RogueTeam {
  id: number;
  username: string;
  usernameDisplay: string;
  activeMember: boolean;
  updateTimestamp: Date;
}
